import { Button } from '@core/ui';

import { ChangePasswordFormSaveButtonProps } from './types';

export const ChangePasswordFormSaveButton = ({ children, classNames, ...props }: ChangePasswordFormSaveButtonProps) => {
    return (
        <Button variant="primary" classNames={`${classNames}`} {...props}>
            {children}
        </Button>
    );
};
